import { z } from "zod";
import { BudgetCategorySchema } from "./budget";
import { ImportConfidenceSchema } from "./guest";
import { VendorStatusSchema } from "./vendor";
export const BudgetDocumentTypeSchema = z.enum(["contract", "receipt"]);
/**
 * Intermediate shape for the AI budget-import wizard. Accumulated in memory,
 * edited by the user, then mapped to VendorInput + BudgetItem on commit.
 */
export const ParsedBudgetDocumentSchema = z.object({
    id: z.string(),
    documentType: BudgetDocumentTypeSchema,
    vendorName: z.string().min(1),
    category: BudgetCategorySchema,
    contactName: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    website: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    status: VendorStatusSchema,
    contractAmount: z.number().nonnegative().default(0),
    vendorDepositPaid: z.number().nonnegative().default(0),
    estimatedCost: z.number().nonnegative().default(0),
    actualCost: z.number().nonnegative().default(0),
    depositPaid: z.number().nonnegative().default(0),
    dueDate: z.string().datetime().nullable().optional(),
    isPaid: z.boolean().default(false),
    notes: z.string().nullable().optional(),
    confidence: ImportConfidenceSchema.default("medium"),
    suggestedVendorId: z.string().nullable().optional(),
    linkToExisting: z.boolean().default(false),
});
